import { FindingTypeProperty } from '../../AnnotationStandardForm/AnnotationStandardForm.slice';
import { AnnotationsForGrid } from '../annotation.types';

export const getUniqueFindingType = (annotationsForEdit: AnnotationsForGrid[]) => {
  const findingTypes = annotationsForEdit.map(annotation => {
    const findingTypeId = annotation.findingTypeId;
    return findingTypeId;
  });

  if (findingTypes.length === 0) {
    return null;
  }

  if (findingTypes.every(x => x === findingTypes[0])) {
    return findingTypes[0];
  }

  return null;
};

export const areAllPropertyValuesSame = (properties: FindingTypeProperty[], annotationsForEdit: AnnotationsForGrid[] | null) => {
  let areAllTheSame = true;

  if (!annotationsForEdit) {
    return false;
  }

  properties.forEach(property => {
    const propertyValues = annotationsForEdit.map(annotation => {
      const currentProperty = annotation.properties.find(x => x.name === property.name);
      return currentProperty?.value;
    });

    areAllTheSame = propertyValues.every(x => propertyValues[0] === x);
  });

  return areAllTheSame;
};

export const getPropertyInitialValue = (
  areAllValuesSame: boolean,
  property: FindingTypeProperty,
  annotationsForEdit: AnnotationsForGrid[] | null
): string => {
  if (areAllValuesSame && property && annotationsForEdit) {
    const annotationProperty = annotationsForEdit[0].properties.find(x => x.name === property.name);

    if (annotationProperty) {
      return annotationProperty.value;
    }
  }

  return '';
};
